import ForgotPasswordForm from '@features/recovery/forgot-password-form/forgot-password-form';
export default ForgotPasswordForm;
